<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="320" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-4 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            Vincular estados
          </h2>
        </div>
        <div class="flex-shrink-0">
        </div>
      </header>

      <div class="px-4 py-4 space-y-4 bg-white">
        <group-status-link-form ref="refGroupStatusLinkForm"
          :ungrouped-states="data"
          :weighting-criteria="weightingCriteria"
          :show-actions="false"
        />
      </div>

      <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-end space-x-2">
          <v-button v-if="!processingData" @click="addItem()" icon="plus" size="is-small">{{ $t('add') }}</v-button>
          <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="isModalActive = false">{{ $t('close') }}</v-button>

          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import GroupStatusLinkForm from './group-status-link-form.vue';

export default {
  name: "LayerGroupStatusLinkModal",

  components: {
    GroupStatusLinkForm
  },

  props: {
  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,

      data: null,
      group: null,
      layerId: null,
      weightingCriteria: null, // Criterio de ponderación, si se usa
    }
  },

  computed: {

  },

  created() {
  },

  methods: {

    async addItem() {
      const status = this.$refs.refGroupStatusLinkForm.getData();
      const groupId = this.group ? this.group.id : null;
      // Emit puro — el padre llamará al manager para hacer el POST + merge.
      this.$emit('epc-group-status-link', { status, groupId });
      this.hide();
    },

    show(data) {
      this.data = data.data;
      this.weightingCriteria = data.weightingCriteria; // Establecer el criterio de ponderación si se proporciona
      this.group = data.group; // Establecer el grupo si se proporciona
      this.layerId = data.layerId;
      this.isModalActive = true;
    },

    hide() {
      this.data = null;
      this.weightingCriteria = null; // Reiniciar el criterio de ponderación
      this.group = null;
      this.layerId = null;

      this.isModalActive = false;

    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
